import React, { useContext, useState } from "react";
import { Avatar, useToast, Button, Flex, Tooltip } from "@chakra-ui/react";
import ReusableText from "../UI/ReusableText";
import SelectComponent from "../UI/Select";
import TextareaComponent from "../UI/Textarea";
import ReusableSupportingDocuments from "../UI/ReusableSupportingDocuments";
import { approveQueries, editQueries } from "../../util/http";
import { AuthContext } from "../../util/context";

export default function QueryDetail({ query }) {
  const toast = useToast();
  const [decision, setDecision] = useState("");
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);

  const { user } = useContext(AuthContext);

  const statusOpt = query?.decision?.toLowerCase() !== "pending";

  const canSelect =
    query?.decision?.toLowerCase() !== "resolved" &&
    query?.decision?.toLowerCase() !== "unresolved";

  const roleOpt =
    user?.job_role?.toLowerCase() === "hr" ||
    user?.job_role?.toLowerCase() === "seed";

  const canReopen = roleOpt && statusOpt;

  async function approveQueryHandler(status) {
    const data = {
      decision: status,
    };

    try {
      setLoading1(true);
      await approveQueries(query?.query_id, data);
      toast({
        title: "Query decision updated",
        description: "",
        status: "success",
        duration: 9000,
        isClosable: true,
        position: "top-right",
      });
      window.location.reload();
      setLoading1(false);
    } catch (error) {
      setLoading1(false);
      toast({
        title: `Error`,
        description: `${
          error?.response?.data.message || "something went wrong"
        }`,
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    }
  }

  async function addComment() {
    const data = {
      comment,
    };

    try {
      setLoading(true);
      await editQueries(query?.query_id, data);
      toast({
        title: "Comment added",
        description: "",
        status: "success",
        duration: 9000,
        isClosable: true,
        position: "top-right",
      });
      window.location.reload();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast({
        title: `Error`,
        description: `${
          error?.response?.data.message || "something went wrong"
        }`,
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    }
  }

  return (
    <Flex direction="column" gap="1rem" w="100%">
      <Flex align="center" w="100%" justify="space-between">
        <Flex w="50%" direction="column" align="start">
          <ReusableText
            text="Due date"
            color="var(--gray)"
            size="14px"
            weight="medium"
          />
          <ReusableText
            text={query?.due_date}
            color="var(--light_gray)"
            size={{ lg: "18px", md: "16px", base: "14px" }}
            weight="medium"
          />
        </Flex>
        <Flex w="50%" direction="column" align="start">
          <ReusableText
            text="Priority Level"
            color="var(--gray)"
            size="14px"
            weight="medium"
          />
          <ReusableText
            text={query?.priority}
            color="var(--light_gray)"
            size={{ lg: "18px", md: "16px", base: "14px" }}
            weight="medium"
          />
        </Flex>
      </Flex>
      <Flex align="start" direction="column" gap="0.5rem">
        <ReusableText
          text="Query description"
          color="var(--gray)"
          size="14px"
          weight="medium"
        />
        <ReusableText
          text={query?.description}
          color="var(--light_gray)"
          size={{ lg: "18px", md: "16px", base: "14px" }}
          weight="medium"
        />
      </Flex>
      <Flex
        w={{ lg: "80%", md: "100%", base: "100%" }}
        align="center"
        justify="center"
      >
        <ReusableSupportingDocuments docs={query?.documents} />
      </Flex>

      <Flex
        w={{ lg: "80%", md: "100%", base: "100%" }}
        direction="column"
        gap="1rem"
        align="start"
        justify="center"
        maxHeight="50vh"
        overflow="scroll"
      >
        {query?.comments?.map((el) => (
          <Flex
            bg="rgba(238, 239, 243, 0.45)"
            p="1rem"
            borderRadius="8px"
            align="start"
            direction="column"
            gap="1rem"
            w="100%"
          >
            <Flex w="100%" align="start" direction="column">
              <ReusableText
                text={el.employee}
                color="var(--gray)"
                size={{ lg: "14px", md: "12px", base: "10px" }}
                weight="medium"
                align="start"
              />
              <ReusableText
                text={el.comment}
                color="var(--light_gray)"
                size={{ lg: "16px", md: "13px", base: "10px" }}
                weight="medium"
                align="start"
              />
            </Flex>
            <Flex align="end" justify="end" w="100%">
              <Flex align="center" gap="1rem">
                <Avatar size="sm" name={el.employee} src="" />
                <Flex align="start" direction="column">
                  <ReusableText
                    text={el.employee}
                    color="#3F434A"
                    size={{ lg: "16px", md: "13px", base: "10px" }}
                    weight="medium"
                    align="start"
                  />
                  <ReusableText
                    text={`${new Date(
                      el.updated_at
                    )?.toLocaleDateString()} ${new Date(
                      el.updated_at
                    )?.toLocaleTimeString()}`}
                    color="#3F434A"
                    size={{ lg: "16px", md: "13px", base: "10px" }}
                    weight="normal"
                    align="start"
                  />
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        ))}
      </Flex>
      <Flex
        w={{ lg: "80%", md: "100%", base: "100%" }}
        align="start"
        gap="1rem"
        direction="column"
        justify="center"
      >
        <TextareaComponent
          label="Comment"
          placeholder="Add comment..."
          onChange={(e) => setComment(e.target.value)}
        />
      </Flex>
      <Flex
        align="end"
        justify="end"
        w={{ lg: "80%", md: "100%", base: "100%" }}
      >
        <Button
          isLoading={loading}
          loadingText="Processing"
          onClick={addComment}
          bg="brand.900"
          variant="solid"
          color="white"
          size="sm"
        >
          Send
        </Button>
      </Flex>
      {canSelect && query?.initiator_id === user?.employee_id && (
        <Flex w="60%">
          {
            <SelectComponent
              label="Select Decision"
              options={["Resolve", "UnResolved"]}
              onChange={(e) => setDecision(e.value)}
            />
          }
        </Flex>
      )}
      <Flex w="100%" align="center" py="3rem" justify="space-between">
        {query?.initiator_id === user?.employee_id && (
          <Tooltip
            hasArrow
            bg="gray.200"
            color="#000"
            label={
              decision?.toLowerCase() === "resolve"
                ? "Resolving this query will close the query and have no negative effect on employee KPI"
                : "Marking this query as un-Resolving will close the query and have negative effect on employee KPI"
            }
          >
            <Button
              isLoading={loading1}
              loadingText="Processing"
              onClick={() => approveQueryHandler(decision)}
              bg="green.500"
              variant="solid"
              color="white"
            >
              Update
            </Button>
          </Tooltip>
        )}

        {canReopen && (
          <Button
            isLoading={loading1}
            loadingText="Processing"
            onClick={() => approveQueryHandler("reopen")}
            bg="red.500"
            variant="solid"
            color="white"
            isDisabled={statusOpt}
          >
            Re-Open
          </Button>
        )}
      </Flex>
    </Flex>
  );
}
